<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>Impressum</lumiron-section-title>
  </lumiron-section-header>

  <lumiron-section-body>
    <div>
      <h3>Adresse</h3>
      <div>
        <p>{{ business.legalName }}</p>
        <p>{{ business.street }}</p>
        <p>{{ business.postalCode }} {{ business.city }}</p>
        <a [href]="'mailto:' + business.email">{{ business.email }}</a>
        <a [href]="'tel:' + business.phoneE164">{{ business.phoneDisplay }}</a>
      </div>
    </div>

    <div>
      <h3>Geschäftsführer</h3>
      <div>
        @for (manager of business.managers; track manager) {
        <p>{{ manager }}</p>
        }
      </div>
    </div>

    <div>
      <h3>Umsatzsteuer-Identifikationsnummer</h3>
      <p>{{ business.uid }}</p>
    </div>
  </lumiron-section-body>
</lumiron-section>
